import type { Step } from "react-joyride";

export const otRequestDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ໃຊ້ເບິ່ງລາຍລະອຽດຄຳຂໍ OT. ຖ້າຍັງລໍຖ້າອະນຸມັດ ທ່ານສາມາດແກ້ໄຂໄດ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="ot-request-detail-back"]',
    content: "ກັບໄປລາຍການຄຳຂໍ OT. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-request-detail-form"]',
    content: "ຂໍ້ມູນຄຳຂໍ: ວັນທີ, ເວລາ, ຊົ່ວໂມງ, ເຫດຜົນ ແລະ ສະຖານະ. ແກ້ໄຂແລ້ວບັນທຶກຖ້າຍັງເປັນລໍຖ້າອະນຸມັດ.",
    placement: "top",
  },
];
